<template>

</template>
<script>
import wxAPI from "@/api/weixin";
import {common} from "@/api/mixins";
export default {
  mixins: [common],
  data() {
    return {
      openId:"",
      account:"",
      password:"",
    };
  },
  created() {
    this.loading = true;
    if(localStorage.bdgj_token) {
      this.loginSuccess();
    // }else if(this.$tools.isWeiXin()){
    //   wxAPI.wxmplogin({}, (data)=>{
    //     if(data.openId) {
    //       this.openidLoginAjax(data);
    //     } else {
    //       this.goLogin();
    //     }
    //   });
    }else{
      this.goLogin();
    }
  },
  methods: {
    openidLoginAjax(data){
      this.$http({
        type: "POST",
        url: "/api/policyManager/loginByOpenId",
        hideAlert:true,
        data: {
          openId:data.openId,
        }
      }).then(resData => {
        if(resData.data&&resData.data.token) {
          localStorage.bdgj_token = resData.data.token;
          localStorage.bdgj_user = JSON.stringify(resData.data.data);
          this.loading = false;
          this.loginSuccess();
        }else{
          this.goLogin();
        }
      }).catch(e =>{
        console.log(e);
        this.goLogin();
      })
    },
    loginSuccess(){
      this.loading = false;
      if(this.$route.query.goPage){
        location.href = this.$route.query.goPage;
      }else if(sessionStorage.bdgjLoginPage){
        location.href = sessionStorage.bdgjLoginPage;
      }else{
        location.replace("/m/bdgj/order")
      }
    },
    // 用token绑定openid
    goLogin(){
      this.loading = false;
      setTimeout(_=>{
        this.$router.replace({
          path:"/m/bdgj/login",
          query: {
            noAutoLogin:1,
            goPage:this.$route.query.goPage
          }
        })
      },1);
    }
  },

};
</script>

<style lang="scss" scoped>
</style>
